import { RootState } from "../../../../store";
import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { recommendationRestoreByResourceFixedCacheKey } from "../../../utils/constants/fixedCacheKeys";

const dailySelector =
  cloudChiprApi.endpoints.patchUsersMeOrganisationsCurrentRecommendationsDailyOffHoursByResource.select(
    recommendationRestoreByResourceFixedCacheKey,
  );

const weeklySelector =
  cloudChiprApi.endpoints.patchUsersMeOrganisationsCurrentRecommendationsWeeklyOffHoursByResource.select(
    recommendationRestoreByResourceFixedCacheKey,
  );

const rightsizingSelector =
  cloudChiprApi.endpoints.patchUsersMeOrganisationsCurrentRecommendationsRightSizingByResource.select(
    recommendationRestoreByResourceFixedCacheKey,
  );

export const recommendationResourceRestoreLoadingSelector = (
  state: RootState,
): boolean => {
  return !!(
    dailySelector(state)?.isLoading ||
    weeklySelector(state)?.isLoading ||
    rightsizingSelector(state)?.isLoading
  );
};
